/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum FSFBDetectedFrameworks {
  REACT_NATIVE = 0,
  FLUTTER = 1,
  CORDOVA = 2,
  IONIC = 3,
  SWIFTUI = 4,
  JETPACK_COMPOSE = 5,
  CAPACITOR = 6,
  FABRIC = 7,
}
